import React, { useState, useEffect } from "react";
import { useTranslation } from "@/langs/useTranslation";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { UserOutlined } from "@ant-design/icons";
import { getCompanyAccounts } from "@/apis/companyTreeApi";
import { Tree, Button } from "antd";

const updateTreeData = (list, key, children) =>
  list.map(node => {
    if (node.key === key) {
      return {
        ...node,
        children: [...(node.children || []), ...children]
      };
    }
    if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children)
      };
    }
    return node;
  });

const SelectDialog = ({
  visible,
  // setVisible,
  treeData,
  value,
  onChange,
  setTreeData,
  treeDataPool,
  setTreeDataPool,
  onClose
}) => {
  const { t } = useTranslation();
  const [selectKey, setSelectKey] = useState([]);

  const handleOnCancel = () => {
    setSelectKey([]);
    if (onClose) {
      onClose();
    }
  };

  const handleOnOk = () => {
    onChange(
      selectKey.map(key => {
        return {
          receiverId: key,
          receiverName: treeDataPool[key].title || treeDataPool[key].name
        };
      })
    );
    onClose();
    const timer = setTimeout(() => {
      setSelectKey([]);
      clearTimeout(timer);
    }, 100);
  };

  const loadUsersData = async ({ key, children }) => {
    // if (children) {
    //   return
    // }
    const { users } = await getCompanyAccounts({ company_id: key });
    const userPool = {};
    const userData = users.map(item => {
      const user = {
        key: item.id,
        title: item.name,
        name: item.name,
        // checkable: true,
        isUser: true,
        isLeaf: true
      };
      userPool[user.key] = user;

      return user;
    });

    setTreeDataPool(pool => {
      return { ...pool, ...userPool };
    });

    setTreeData(prevData => updateTreeData(prevData, key, userData));
  };

  const titleRender = item => {
    if (item.isUser) {
      return (
        <span>
          <UserOutlined /> {item.title}
        </span>
      );
    }
    return item.title;
  };

  useEffect(() => {
    if (visible) {
      setSelectKey(value?.map(item => item.receiverId) || []);
    }
  }, [visible, value]);

  return (
    <Dialog onClose={handleOnCancel} open={visible}>
      <DialogTitle id="select-dialog-title">
        {t({ defaultMessage: "选择用户" })}
      </DialogTitle>
      <DialogContent style={{ width: 500, height: 480 }}>
        <div style={{ height: 400 }}>
          <Tree
            multiple
            treeData={treeData}
            checkable
            checkStrictly
            height={400}
            // selectedKeys={selectKey}
            checkedKeys={selectKey}
            // onSelect={setSelectKey}
            onCheck={v => setSelectKey(v.checked)}
            loadData={loadUsersData}
            titleRender={titleRender}
          />
        </div>

        <div style={{ marginTop: 20, textAlign: "end" }}>
          <Button onClick={handleOnCancel} style={{ marginRight: 15 }}>
            {t({ defaultMessage: "取消" })}
          </Button>
          <Button type="primary" onClick={handleOnOk}>
            {t({ defaultMessage: "确定" })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectDialog;
